import React from 'react';

interface ExternalLinkProps {
  href: string;
  text: string;
  className?: string;
}

const ExternalLink: React.FC<ExternalLinkProps> = ({ href, text, className }) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`text-blue-600 hover:underline ${className || ''}`}
    >
      {text}
    </a>
  );
};

export default ExternalLink;
